import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../../lib/api";
import { BTN, INPUT, errMsg } from "../../components/crm/crmUtil";

// B5 part 2b: client proposal page (one-time link): read the proposal version, accept or decline with a comment.
export default function ClientProposal() {
  const { token } = useParams();
  const [p, setP] = useState(null);
  const [f, setF] = useState({ name: "", comment: "" });
  const [msg, setMsg] = useState({ err: "", done: "" });
  useEffect(() => { api.get(`/sales/public/proposals/${token}`).then((r) => setP(r.data)).catch((e) => setMsg({ err: errMsg(e), done: "" })); }, [token]);
  const decide = async (decision) => {
    try { await api.post(`/sales/public/proposals/${token}/decide`, { decision, name: f.name.trim(), ...(f.comment.trim() && { comment: f.comment.trim() }) }); setMsg({ err: "", done: decision === "accept" ? "Accepted. Thank you." : "Declined. Thank you for letting us know." }); }
    catch (e) { setMsg({ err: errMsg(e), done: "" }); }
  };
  return (
    <main className="min-h-screen bg-erf-cream px-4 py-8" data-testid="client-proposal">
      <div className="mx-auto max-w-3xl space-y-4">
        <h1 className="font-display text-2xl font-semibold">{p?.company || "Proposal"}{p ? ` — proposal v${p.version_no}` : ""}</h1>
        {msg.err && <p role="alert" className="text-sm text-red-700" data-testid="proposal-error">{msg.err}</p>}
        {msg.done && <p role="status" className="text-green-800" data-testid="proposal-done">{msg.done}</p>}
        {p && !msg.done && (
          <>
            <section className="bg-white border border-erf-borderCream rounded p-4 space-y-2 text-sm">
              {p.cover_letter && <p>{p.cover_letter}</p>}
              <p><strong>Scope:</strong> {p.scope_summary || "—"}</p>
              {(p.estimate.sections || []).map((s) => (
                <div key={s.id}><h2 className="font-semibold mt-2">{s.name}</h2>
                  <ul>{s.lines.map((l) => <li key={l.id} className="flex justify-between gap-2"><span>{l.description} · {l.qty} {l.unit}</span><span className="font-mono">${Number(l.extended_price).toFixed(2)}</span></li>)}</ul>
                </div>
              ))}
              <p className="text-base font-semibold" data-testid="proposal-total">Total ${p.estimate.money?.total ?? p.estimate.total}</p>
              {p.estimate.exclusions?.length > 0 && <p><strong>Exclusions:</strong> {p.estimate.exclusions.join("; ")}</p>}
            </section>
            <section className="bg-white border border-erf-borderCream rounded p-4 space-y-2">
              <label htmlFor="pr-name" className="text-sm block">Your name<input id="pr-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className={INPUT} data-testid="proposal-name" /></label>
              <label htmlFor="pr-comment" className="text-sm block">Comments (optional)<textarea id="pr-comment" rows={3} value={f.comment} onChange={(e) => setF({ ...f, comment: e.target.value })} className={`${INPUT} py-2`} data-testid="proposal-comment" /></label>
              <div className="flex flex-wrap gap-2">
                <button type="button" disabled={f.name.trim().length < 2} onClick={() => decide("accept")} className={`${BTN} bg-erf-gold text-erf-dark`} data-testid="proposal-accept">Accept</button>
                <button type="button" disabled={f.name.trim().length < 2} onClick={() => decide("decline")} className={`${BTN} border border-erf-borderCream`} data-testid="proposal-decline">Decline</button>
              </div>
            </section>
          </>
        )}
      </div>
    </main>
  );
}
